import React from "react";
import { formatDate } from "../../../../../../functions/dateTime/formatDate";
import dialogIcon from "../../../../../../assets/icons/dialog icon.svg";

const DispatchHistoryView = ({ item, type, onDialogClick }) => {
  const handleClick = () => {
    onDialogClick(item, type);
  };
  return (
    <div className="cy-history-blue-line">
      <p className="cy-history-blue-dot"></p>
      <div className="cy-history-box-gray mt-4">
        <div className="cy-history-state-head">
          <p className="cy-history-dispatched">Dispatched</p>
          <p>{formatDate(item.createdAt)}</p>
        </div>
        <div className="cy-history-flexEnd">
          <div>
            <p className="cy-history-showStation">
              {item.fromStation.name}{" "}
              <span className="text-xs">({item.fromStation.id})</span>
            </p>
            <p className="text-sm">(Dispatched By: {item.createdBy.fullName})</p>
          </div>
          <button className="cy-history-viewBtn" onClick={handleClick}>
            <img src={dialogIcon} alt="view" className="mr-1" />
            View
          </button>
        </div>
      </div>
    </div>
  );
};

export default React.memo(DispatchHistoryView);
